export default __webpack_public_path__ + "static/media/news33.ee86fdbb.jpg";